import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import useQueryParams from "@/hooks/useQueryParams";

/** Client-side windowing for DataTable + PaginationComp offset mode (URL page / pageSize). */
export function useClientSideTableSlice(rows, { defaultPageSize = 10 } = {}) {
  const { getParam } = useQueryParams();
  const { search } = useLocation();

  const pageSizeRaw = Number(getParam("pageSize")) || defaultPageSize;
  const pageSize = Math.min(50, Math.max(1, pageSizeRaw));
  const rawPage = Math.max(1, Number(getParam("page")) || 1);
  const totalCount = rows?.length ?? 0;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize) || 1);
  const page = Math.min(rawPage, totalPages);

  const data = useMemo(() => {
    if (!rows?.length) return [];
    const start = (page - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, page, pageSize, search]);

  return { data, count: totalCount, pageSize, page };
}
